export default __webpack_public_path__ + "static/media/elevate-red-3.e345c4f7.png";